module.exports = __webpack_public_path__ + "img/everton-logo-icon.594bc0a0.png";